import type {
    SharedShorthandTransactionsFeatures,
    SharedTransactionsFeatures,
} from '../types/SharedTransactionsFeatures';

export const features: SharedTransactionsFeatures = {
    print: {
        enabled: true,
        _description: `
            Enables the Transaction History Print feature.
            (Surfaced through a button on the Account History screen.)
        `,
    },
    export: {
        enabled: true,
        _description: `
            Enables the Transaction History Export feature.
            (Surfaced through a button on the Account History screen.)
        `,
    },
    displayExecutionDate: {
        enabled: false,
        _description: 'Displays Execution date instead of Booking date in transaction history.',
    },
    replaceBulkTransactions: {
        enabled: false,
        _description:
            'Enables user-controlled switching of search in bulk transactions or contained transactions.',
    },
    productStatementFilter: {
        enabled: false,
        _description:
            'Allows filtering statements within transaction search for a specific product.',
    },
    globalStatementFilter: {
        enabled: false,
        _description: 'Enables filtering statements within transaction search across all products.',
    },
    debitCardFilter: {
        enabled: false,
        _description: 'Enables debit card filter in transaction history.',
    },
    creditCardFilter: {
        enabled: false,
        _description: 'Enables credit card filter in Card Account transaction history.',
    },
    variableSymbolFilter: {
        enabled: false,
        _description: 'Enables variable symbol filter in transaction history.',
    },
    continuousCardIdFiltering: {
        enabled: false,
        _description:
            'Enables the continuousCardIdFiltering flag on transactions list and export requests',
        debitCards: {
            enabled: false,
            _description: 'Uses continuousCardId query param for Debit card filtering',
        },
        authorizedCardsByTransactionAccount: {
            enabled: false,
            _description: 'Uses continuousCardId query param for Authorized card filtering',
        },
        authorizedCardsByShadowAccount: {
            enabled: false,
            _description: `
                Uses continuousCardId query param for Authorized card filtering
                when list of available cards is fetched by shadow account
            `,
        },
    },
    paymentOrderLink: {
        enabled: false,
        _description: 'Enables fetching of payment order links for bulk transactions',
    },
    startingAndEndingBalance: {
        enabled: false,
        _description: 'Enables starting and ending balances for aggregations balance.',
    },
    history: {
        initialBalanceAvailabilityAlert: {
            enabled: false,
            _description:
                'Displays infobox in product history when account balance data is not available for current search.',
        },
        initialBalancePrintExport: {
            enabled: false,
            _description: 'Enables showing starting and ending balances for print and export.',
        },
    },
};

export const shorthandFeatures: SharedShorthandTransactionsFeatures = {
    detPrintV2: {
        enabled: false,
        _description:
            'Enables the new Export Service for Transaction Details Print (sends &template=v2).',
    },
    sortAccHis: {
        enabled: false,
        _description: 'Enables sorting of transactions history',
    },
    sortGlobalSearch: {
        enabled: false,
        _description: 'Enables sorting of transactions in global search results.',
    },
};
